import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";
export default class FinancialItemModel extends BaseModel {
  uuid = null;
  inventory_uuid = null;
  hammer_price = null;
  hammer_adjustment = null;
  premium = null;
  premium_vat = null;
  import_tax = null;
  quantity = null;
  lot_no = null;
  input_vat = null;
  collected = false;
  invoice_no = null;
  is_create = false;
  exclude_tax_for_premium = null;
  exclude_tax_for_hammer_price = null;
  introductory_commission = null;
  introductory_commission_vat = 0;
  introductory_commission_taxable = false;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    quantity: 'required',
    hammer_price: 'required|min_value:0.1',
    inventory_uuid: 'required',
  };

  attributeLabels = {
    collected: i18n.t('Collected'),
    invoice_no: i18n.t('Invoice'),
  };

  toJSON() {
    let data = super.toJSON();
    if (data.is_create) {
      delete data.uuid;
    }
    delete data.is_create;
    return data;
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
